import React from 'react';
import PropTypes from 'prop-types';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

function TypeaheadSuggestion({ value = '', query = '', ...props }) {
    const matches = match(value, query);
    const parts = parse(value, matches);

    return (
        <span {...props}>
            {parts.map((part, index) =>
                part.highlight ? (
                    <span
                        key={String(index)}
                        style={{ fontWeight: 600 }}
                    >
                        {part.text}
                    </span>
                ) : (
                    <strong
                        key={String(index)}
                        style={{ fontWeight: 400 }}
                    >
                        {part.text}
                    </strong>
                )
            )}
        </span>
    );
}

TypeaheadSuggestion.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    query: PropTypes.string,
};

export default TypeaheadSuggestion;
